import React from "react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function MovingProcess() {
    useScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="main-title js-scroll fade-top">
                <div>Our Moving Process</div>
            </div>
            <div className="container py-[20px] flex flex-col gap-[20px] items-center justify-center">
                <div className="flex flex-col items-center justify-center text-center">
                    <div className="js-scroll fade-top font-bold capitalize text-[25px]">Moving Made Easy with M Power Moving Services</div>
                    <p className="js-scroll fade-btm w-[75%]">We ensure a smooth and secure transition to your new destination with our streamlined process</p>
                </div>
                <div className="flex items-center justify-between flex-wrap">
                    <img className="w-100 js-scroll fade-left w-[40%] h-full" src={require("../../assets/image/step-1.svg").default} alt="" />
                    <img className="d-none js-scroll fade-left w-[15%] h-auto" src={require("../../assets/image/arrow.png")} alt="" />
                    <img className="w-100 js-scroll fade-right w-[40%] h-full" src={require("../../assets/image/step-2.svg").default} alt="" />
                    <img className="w-100 js-scroll fade-left w-[40%] h-full" src={require("../../assets/image/step-3.svg").default} alt="" />
                    <img className="d-none js-scroll fade-left w-[15%] h-auto" src={require("../../assets/image/arrow.png")} alt="" />
                    <img className="w-100 js-scroll fade-right w-[40%] h-full" src={require("../../assets/image/step-4.svg").default} alt="" />
                </div>
            </div>
        </section>
    );
}